export default "__VITE_ASSET__C31k05pK__"